const Product = {
  log: window.log,
  bindStickyBar: window.bindStickyBar,

  init() {
    this.initDeliveryEstimation();
    this.bindStickyBar('.na_sticky_bar_outer', '.pdp-main', 320);

    const hasKachingAtc = document.querySelector('pdp-kaching-atc') !== null;
    const hasQuantityOptions = $('.pdp-main__quantity-options').length > 0;
    const hasBogoOptions = $('.pdp-main__bogo-options').length > 0;
    if (hasQuantityOptions) {
      this.quantitySelector();
    } else if (hasBogoOptions) {
      this.bogoSelector();
    } else if (!hasKachingAtc) {
      this.variantSelector();
    }
    this.initUpdate();
    if (!hasKachingAtc) this.addToCart();
  },

  initDeliveryEstimation() {
    const currentCountry = $('.countr_code_sel__js').attr('value');
    const deliveryEl = $('.pdp-main__product-delivery')
    const deliveryDaysRaw = deliveryEl.data('delivery-days');
    const deliveryMonthsRaw = deliveryEl.data('delivery-months');
    const deliveryDays = Array.isArray(deliveryDaysRaw) ? deliveryDaysRaw.map(d => d.value) : [];
    const deliveryMonths = Array.isArray(deliveryMonthsRaw) ? deliveryMonthsRaw.map(m => m.value) : [];

    const deliveryConditions = deliveryEl.data('delivery-conditions');
    const productDeliveryConditions = deliveryEl.data('product-delivery-conditions');
    const deliveryDefaultEstimation = +(deliveryEl.data('delivery-default-estimation')) || 1;
    this.log.collapse({ currentCountry, deliveryDays, deliveryMonths, deliveryConditions, productDeliveryConditions, deliveryDefaultEstimation }, "Delivery Data", "success");

    const calcEstimation = (country, conditions, defEst) =>
      (conditions || []).find(c => c.countries?.includes(country))?.delivery_estimation ?? defEst;

    const deliveryEstimation = calcEstimation(currentCountry, productDeliveryConditions || deliveryConditions, deliveryDefaultEstimation);
    this.calculateDeliveryDate(deliveryEstimation, deliveryDays, deliveryMonths, deliveryConditions);
  },

  calculateDeliveryDate(daysToAdd, days, months) {
    const currentDate = new Date();

    const addBusinessDays = (startDate, numDays) => {
      const resultDate = new Date(startDate);
      let addedDays = 0;
      while (addedDays < numDays) {
        resultDate.setDate(resultDate.getDate() + 1);
        if (resultDate.getDay() !== 0 && resultDate.getDay() !== 6) {
          addedDays++;
        }
      }
      return resultDate;
    };

    const firstDeliveryDate = addBusinessDays(currentDate, daysToAdd);
    const formattedDate = `${days[firstDeliveryDate.getDay()]}, ${firstDeliveryDate.getDate()} ${months[firstDeliveryDate.getMonth()]}`;
    $('.pdp-main__product-delivery .delivery_date').text(formattedDate);
  },

  formatMoney(amount) {
    return (window.formatMoney || ((v) => v))(amount);
  },

  setDiscountText($el, template, saveAmount, savePercentage) {
    if (!template) {
      $el.text(`Save ${this.formatMoney(saveAmount)}`).removeClass('hidden');
      return;
    }
    const pct = String(savePercentage).includes('%') ? savePercentage : `${savePercentage}%`;
    $el.html(template
      .replace('[discount]', `<span class="discount-amount">${this.formatMoney(saveAmount)}</span>`)
      .replace('[discount_percentage]', `<span class="discount-percentage">${pct}</span>`)
    ).removeClass('hidden');
  },

  klarna: $('.pdp-main__klarna span'),

  getVariantData(variantId) {
    return $(`#variations-data .variation-data[data-id="${variantId}"]`);
  },

  getActiveQuantityOption() {
    return $('.pdp-main__quantity-option.active');
  },

  getQuantityOptionVariantIds($option) {
    const selectedVariants = [];

    $option.find('.pdp-main__product-options-select').each(function () {
      let $selected = $(this).find('.main-select__item[data-selected="true"]');
      if (!$selected.length) $selected = $(this).find('.main-select__item').first();
      if ($selected.length) {
        const variantId = $selected.data('value');
        if (variantId) selectedVariants.push(variantId);
      }
    });

    if (selectedVariants.length) return selectedVariants;

    const fallbackId = this.selectedVar.data('id') || $('#variations-data .variation-data').first().data('id');
    if (!fallbackId) return [];

    const quantity = parseInt($option.attr('data-quantity') || $option.data('quantity'), 10) || 1;
    return Array.from({ length: quantity }, () => fallbackId);
  },

  getSelectedVariants() {
    const $activeOption = this.getActiveQuantityOption();
    if (!$activeOption.length) return [];
    return this.getQuantityOptionVariantIds($activeOption);
  },

  calculateQuantityOptionPrice($option) {
    const selectedVariants = this.getQuantityOptionVariantIds($option);
    if (selectedVariants.length === 0) return null;

    let totalPrice = 0;
    let totalComparePrice = 0;
    let allAvailable = true;
    let servingsPerPackage = 0;

    selectedVariants.forEach((variantId, index) => {
      const $variant = this.getVariantData(variantId);
      if ($variant.length) {
        const price = parseFloat($variant.attr('data-price')) || parseFloat($variant.data('price')) || 0;
        const comparePrice = parseFloat($variant.attr('data-compare-price')) || parseFloat($variant.data('compare-price')) || 0;
        totalPrice += price;
        totalComparePrice += comparePrice;
        const available = $variant.attr('data-available') === 'true' || $variant.data('available') === true;
        if (!available) allAvailable = false;

        if (index === 0) {
          servingsPerPackage = parseFloat($variant.attr('data-servings')) || parseFloat($variant.data('servings')) || 0;
        }
      }
    });

    if (totalPrice === 0 && totalComparePrice === 0) return null;

    const discountPercent = parseFloat($option.attr('data-discount-percentage')) || parseFloat($option.data('discount-percentage')) || 0;
    const quantity = parseFloat($option.attr('data-quantity')) || parseFloat($option.data('quantity')) || 1;
    const discountMultiplier = (100 - discountPercent) / 100;
    const discountedPrice = totalPrice * discountMultiplier;
    const pricePerPackage = totalPrice / quantity * discountMultiplier;
    const comparePricePerPackage = totalComparePrice / quantity;
    const saveAmount = totalComparePrice - discountedPrice;
    const totalServings = quantity * servingsPerPackage;
    const pricePerServing = totalServings > 0 ? discountedPrice / totalServings : 0;


    return {
      price: discountedPrice,
      comparePrice: totalComparePrice,
      saveAmount: saveAmount > 0 ? saveAmount : 0,
      savePercentage: discountPercent,
      servings: totalServings,
      pricePerPackage,
      comparePricePerPackage,
      pricePerServing: pricePerServing,
      available: allAvailable
    };
  },

  updateQuantityOptionPrice($option) {
    const prices = this.calculateQuantityOptionPrice($option);
    if (!prices) return;

    const $priceEl = $option.find('.pdp-main__quantity-option-price');
    if (!$priceEl.length) return;

    // const priceFormatted = this.formatMoney(prices.price);
    // const compareFormatted = this.formatMoney(prices.comparePrice);
    // Pricing per Package
    const priceFormatted = this.formatMoney(prices.pricePerPackage);
    const compareFormatted = this.formatMoney(prices.comparePricePerPackage);

    $priceEl.find('span').first().text(priceFormatted);
    const $compareEl = $priceEl.find('s');
    if (prices.comparePrice > prices.price && $compareEl.length) {
      $compareEl.text(compareFormatted).removeClass('hidden');
    } else {
      $compareEl.addClass('hidden');
    }

    const $pricePerServing = $option.find('.price_per_serving');
    if ($pricePerServing.length && prices.pricePerServing > 0) {
      $pricePerServing.text(this.formatMoney(prices.pricePerServing));
    }
  },

  updateMainPriceDisplay() {
    const $activeOption = this.getActiveQuantityOption();
    if (!$activeOption.length) return;

    const prices = this.calculateQuantityOptionPrice($activeOption);
    if (!prices) return;

    const priceFormatted = this.formatMoney(prices.price);
    const compareFormatted = this.formatMoney(prices.comparePrice);


    const $pricesEl = $('.pdp-main__prices');
    if ($pricesEl.length) {
      const $comparePrice = $pricesEl.find('s');
      const $currentPrice = $pricesEl.find('h3');
      const $saveText = $pricesEl.find('p');
      const discountText = $saveText.data('discount-text');

      $currentPrice.text(priceFormatted);

      if (prices.comparePrice > prices.price) {
        $comparePrice.text(compareFormatted).removeClass('hidden');
      } else {
        $comparePrice.addClass('hidden');
      }

      if (prices.saveAmount > 0) {
        this.setDiscountText($saveText, discountText, prices.saveAmount, prices.savePercentage);
      } else {
        $saveText.addClass('hidden');
      }
    }

    if (this.klarna.length > 0) {
      const divideBy = Number(this.klarna.data('divide')) || 4;
      const klarnaAmount = prices.price / divideBy;
      this.klarna.text(this.formatMoney(klarnaAmount));
    }

    const atcBtn = $('.pdp-main__atc-btn');
    const atcTextEl = atcBtn.find('span:not(.money)').first();
    const { mainText, soldOutText } = atcTextEl.data();
    if (!prices.available) {
      atcBtn.addClass('soldout');
      atcTextEl.text(soldOutText || 'Sold Out');
      atcBtn.find('.money').text('');
    } else {
      atcBtn.removeClass('soldout');
      atcTextEl.text(mainText || 'Add to Cart');
      atcBtn.find('.money').text(priceFormatted);
      if (prices.comparePrice > prices.price) {
        atcBtn.find('.money-compare').removeClass('hidden').text(compareFormatted);
      } else {
        atcBtn.find('.money-compare').addClass('hidden');
      }
    }
  },

  quantitySelector() {
    $(document).on('click', '.pdp-main__quantity-option', (e) => {
      const $option = $(e.currentTarget);
      if ($(e.target).closest('.pdp-main__product-options-select').length) return;
      if ($option.hasClass('active')) return;

      $('.pdp-main__quantity-option').removeClass('active');
      $option.addClass('active');
      this.updateMainPriceDisplay();
    });

    $(document).on('click', '.pdp-main__quantity-option .main-select__item', (e) => {
      const $clickedItem = $(e.currentTarget);
      if ($clickedItem.hasClass('soldout')) {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
        return false;
      }
      const $option = $clickedItem.closest('.pdp-main__quantity-option');

      if (!$option.hasClass('active')) {
        $('.pdp-main__quantity-option').removeClass('active');
        $option.addClass('active');
      }

      this.updateQuantityOptionPrice($option);
      this.updateMainPriceDisplay();
    });
  },

  getActiveBogoOption() {
    return $('.pdp-main__bogo-option.active');
  },

  calculateBogoOptionPrice($option) {
    const $subscriptionCheckbox = $('.pdp-main__sub-input');
    const isSubscription = $subscriptionCheckbox.length && $subscriptionCheckbox.is(':checked');

    const quantity = parseFloat($option.attr('data-quantity')) || parseFloat($option.data('quantity')) || 1;
    const freeQuantity = parseFloat($option.attr('data-free-quantity')) || parseFloat($option.data('free-quantity')) || 0;
    const totalQuantitySub = parseFloat($option.attr('data-total-quantity-sub')) || parseFloat($option.data('total-quantity-sub')) || quantity;

    let price = parseFloat($option.attr('data-price')) || parseFloat($option.data('price')) || 0;
    let comparePrice = parseFloat($option.attr('data-compare-price')) || parseFloat($option.data('compare-price')) || price;

    if (isSubscription) {
      const subPrice = parseFloat($option.attr('data-sub-price')) || parseFloat($option.data('sub-price')) || price;
      price = subPrice;
      comparePrice = subPrice;

      const totalPrice = price * quantity;
      const totalComparePrice = price * totalQuantitySub;
      const saveAmount = totalComparePrice - totalPrice;
      const savePercentage = Math.round((freeQuantity / totalQuantitySub) * 100);

      return {
        price: totalPrice,
        comparePrice: totalComparePrice,
        saveAmount: saveAmount > 0 ? saveAmount : 0,
        savePercentage: savePercentage,
        quantity: totalQuantitySub,
        paidQuantity: quantity,
        freeQuantity: freeQuantity,
        isSubscription: true
      };
    } else {
      const totalPrice = price * quantity;
      const totalComparePrice = comparePrice * quantity;
      const saveAmount = 0;

      return {
        price: totalPrice,
        comparePrice: totalComparePrice,
        saveAmount: saveAmount,
        quantity: quantity,
        paidQuantity: quantity,
        freeQuantity: 0,
        isSubscription: false
      };
    }
  },

  updateBogoMainPriceDisplay() {
    const $activeOption = this.getActiveBogoOption();
    if (!$activeOption.length) return;

    const prices = this.calculateBogoOptionPrice($activeOption);
    const priceFormatted = this.formatMoney(prices.price);
    const compareFormatted = this.formatMoney(prices.comparePrice);

    const $pricesEl = $('.pdp-main__prices');
    if ($pricesEl.length) {
      const $comparePrice = $pricesEl.find('s');
      const $currentPrice = $pricesEl.find('h3');
      const $saveText = $pricesEl.find('p');
      const discountText = $saveText.data('discount-text');

      $currentPrice.text(priceFormatted);

      if (prices.comparePrice > prices.price) {
        $comparePrice.text(compareFormatted).removeClass('hidden');
      } else {
        $comparePrice.addClass('hidden');
      }

      if (prices.saveAmount > 0) {
        this.setDiscountText($saveText, discountText, prices.saveAmount, prices.savePercentage);
      } else {
        $saveText.addClass('hidden');
      }
    }

    if (this.klarna.length > 0) {
      const divideBy = Number(this.klarna.data('divide')) || 4;
      const klarnaAmount = prices.price / divideBy;
      this.klarna.text(this.formatMoney(klarnaAmount));
    }

    const atcBtn = $('.pdp-main__atc-btn');
    const atcTextEl = atcBtn.find('span:not(.money)').first();
    const { mainText, soldOutText } = atcTextEl.data();
    if (!prices.available) {
      atcBtn.addClass('soldout');
      atcTextEl.text(soldOutText || 'Sold Out');
    } else {
      atcBtn.removeClass('soldout');
      atcTextEl.text(mainText || 'Add to Cart');
    }
    atcBtn.find('.money').text(priceFormatted);
    if (prices.comparePrice > prices.price) {
      atcBtn.find('.money-compare').removeClass('hidden').text(compareFormatted);
    } else {
      atcBtn.find('.money-compare').addClass('hidden');
    }
  },

  updateBogoOptionsDisplay() {
    const $subscriptionCheckbox = $('.pdp-main__sub-input');
    const isSubscription = $subscriptionCheckbox.length && $subscriptionCheckbox.is(':checked');

    $('.pdp-main__bogo-option').each((index, el) => {
      const $option = $(el);
      const $title = $option.find('.pdp-main__bogo-option-title');
      const $infoLabel = $option.find('.pdp-main__bogo-option-info-label');
      const $priceCurrent = $option.find('.pdp-main__bogo-option-price-current');
      const $priceCompare = $option.find('.pdp-main__bogo-option-price-compare');
      const $saveText = $option.find('.pdp-main__bogo-option-save');

      const title = isSubscription ? ($title.data('title-sub') || $title.data('title')) : $title.data('title');
      const priceNonSub = $priceCurrent.data('price-non-sub') || '';
      const priceSub = $priceCurrent.data('price-sub') || '';
      const compareNonSub = $priceCompare.data('compare-non-sub') || '';
      const compareSub = $priceCompare.data('compare-sub') || '';
      const saveText = $saveText.data('save-text') || '';

      if (title) {
        $title.text(title);
      }

      if ($infoLabel.length) {
        const infoLabelNonSub = $infoLabel.data('info-label-non-sub') || '';
        const infoLabelSub = $infoLabel.data('info-label-sub') || '';
        if (isSubscription && infoLabelSub) {
          $infoLabel.text(infoLabelSub);
        } else if (infoLabelNonSub) {
          $infoLabel.text(infoLabelNonSub);
        }
      }

      if (isSubscription) {
        $priceCurrent.text(priceSub);
        const quantity = parseFloat($option.attr('data-quantity')) || parseFloat($option.data('quantity')) || 1;
        const freeQuantity = parseFloat($option.attr('data-free-quantity')) || parseFloat($option.data('free-quantity')) || 0;
        const totalQuantitySub = parseFloat($option.attr('data-total-quantity-sub')) || parseFloat($option.data('total-quantity-sub')) || quantity;

        if (totalQuantitySub > quantity && compareSub) {
          $priceCompare.text(compareSub).show();
        } else {
          $priceCompare.hide();
        }

        if (freeQuantity > 0 && saveText) {
          const price = parseFloat($option.attr('data-sub-price')) || parseFloat($option.data('sub-price')) || 0;
          const discountAmount = price * freeQuantity;
          const discountPerc = Math.round((freeQuantity / totalQuantitySub) * 100);
          let formattedSaveText = saveText.replace('[discount_perc]', discountPerc);
          formattedSaveText = formattedSaveText.replace('[discount]', this.formatMoney(discountAmount));
          $saveText.text(formattedSaveText).show();
        } else {
          $saveText.hide();
        }
      } else {
        $priceCurrent.text(priceNonSub);
        $priceCompare.hide();
        $saveText.hide();
      }
    });

    this.updateBogoMainPriceDisplay();
  },

  bogoSelector() {
    $(document).on('click', '.pdp-main__bogo-option', (e) => {
      const $option = $(e.currentTarget);
      if ($option.hasClass('active')) return;

      $('.pdp-main__bogo-option').removeClass('active');
      $option.addClass('active');
      this.updateBogoMainPriceDisplay();
    });

    $(document).on('change', '.pdp-main__sub-input', () => {
      this.updateBogoOptionsDisplay();
    });
  },

  variantSelector() {
    const color = $('.pdp-main__product-option.color.active').data('color');
    const size = $('.pdp-main__product-option.size.active').data('size') ||
      $('.pdp-main__product-dropdown').val() ||
      $('.pdp-main__product-options-dropdown__item[data-selected="true"]').data('size');

    this.color = color;
    this.size = size;

    $('.pdp-main__product-option').on('click', (e) => {
      const $option = $(e.currentTarget);
      const group = $option.data('color') ? 'color' : 'size';
      $option.addClass('active').siblings(`.${group}`).removeClass('active');
      this[group] = $option.data(group);
      if (group === 'color') this.updateNote(this.color);
      this.updatePrice();
      this.updateLabel(group);
    });

    $('.pdp-main__product-options-dropdown__item').on('click', (e) => {
      const $item = $(e.currentTarget);
      if (!$item.is('[data-selected="true"]')) {
        $('.pdp-main__product-options-dropdown__item[data-selected="true"]').removeAttr('data-selected');
        $item.attr('data-selected', 'true');
        this.size = $item.data('size');
        this.updatePrice();
        this.updateLabel('size');
        $('.pdp-main__product-options-dropdown').removeClass('open');
      }
    });

    $('.pdp-main__product-options-select').on('change', (e) => {
      this.size = $(e.currentTarget).val();
      this.updatePrice();
      this.updateLabel('size');
    });
  },

  getLabel(group) {
    return group === 'color'
      ? $('.pdp-main__product-option.color.active h4').text()
      : $('.pdp-main__product-option.size.active').text() ||
      $('.pdp-main__product-options-select option:selected').text() ||
      $('.pdp-main__product-options-dropdown__item[data-selected="true"]').find('.item-label').text().trim();
  },

  updateLabel(group) {
    $(`.pdp-main__product-options-label.${group} span`).text(this.getLabel(group));
  },

  get selectedVar() {
    const baseQuery = '#variants-data .variant-data';
    const query = baseQuery + `[data-color="${this.color}"]${this.size ? `[data-size="${this.size}"]` : ''}`;
    const selected = $(query);
    window.product_selected_variant = selected.length ? selected : $(baseQuery);
    return selected.length ? selected : $(baseQuery);
  },

  updatePrice() {
    const selectedVar = this.selectedVar;
    if (selectedVar.length) {
      const price = (selectedVar.data('price') / 100).toFixed(2);
      const comparePrice = (selectedVar.data('compare-price') / 100).toFixed(2);
      const saveAmount = (comparePrice - price).toFixed(2);
      const savePercentage = Math.round(((comparePrice - price) / comparePrice) * 100);
      const klarnaPrice = (price / Number(this.klarna.data('divide'))).toFixed(2);

      const stock = parseInt(selectedVar.data('stock'));
      const available = !!selectedVar.data('available');
      const atcBtn = $('.pdp-main__atc-btn');
      const atcTextEl = atcBtn.find('span:not(.money)').first();
      const { mainText, soldOutText } = atcTextEl.data();
      if (stock <= 0 && !available) {
        atcBtn.addClass('soldout');
        atcTextEl.text(soldOutText || 'Sold Out');
        atcBtn.find('.money').text('');
      } else {
        atcBtn.removeClass('soldout');
        atcTextEl.text(mainText || 'Add to Cart');
        atcBtn.find('.money').text(this.formatMoney(price));
      }

      this.updateMainPriceDisplayLegacy(comparePrice, price, saveAmount, savePercentage);
      if (this.klarna.length > 0) this.klarna.text(this.formatMoney(klarnaPrice));
    }
  },

  updateMainPriceDisplayLegacy(originalPrice, discountedPrice, saveAmount, savePercentage) {
    const $prices = $('.pdp-main__prices');
    const $saveText = $prices.find('p');
    $prices.find('s').text(this.formatMoney(originalPrice));
    $prices.find('h3').text(this.formatMoney(discountedPrice));
    this.setDiscountText($saveText, $saveText.data('discount-text'), saveAmount, savePercentage);
  },

  updateNote: color => $('.pdp-main__price-note').toggleClass('hidden', color === 'gold-24k'),

  initUpdate() {
    const hasQuantityOptions = $('.pdp-main__quantity-options').length > 0;
    const hasBogoOptions = $('.pdp-main__bogo-options').length > 0;

    if (hasQuantityOptions) {
      $('.pdp-main__quantity-option').each((_, el) => {
        this.updateQuantityOptionPrice($(el));
      });

      const $activeOption = this.getActiveQuantityOption();
      if ($activeOption.length) {
        this.updateMainPriceDisplay();
      }
    } else if (hasBogoOptions) {
      this.updateBogoOptionsDisplay();
      const $activeOption = this.getActiveBogoOption();
      if ($activeOption.length) {
        this.updateBogoMainPriceDisplay();
      }
    } else {
      this.updatePrice();
      this.updateLabel('color');
      this.updateLabel('size');
      this.updateNote(this.color);
    }
  },

  addToCart() {
    $('.pdp-main__atc-btn').click((e) => {
      e.preventDefault();
      const $btn = $(e.currentTarget);
      if ($btn.hasClass('soldout')) {
        const productTitle = $('.pdp-main').data('product-title') || document.title?.split('|')[0]?.trim() || 'This product';
        window.showToast && window.showToast('soldout_product', { productTitle });
        return;
      }

      const cartUrl = window.getCartUrl();

      if ($('.pdp-main__quantity-options').length > 0) {
        // Quantity selector mode
        const selectedVariants = this.getSelectedVariants();
        if (selectedVariants.length === 0) {
          return alert('Please select all product options.');
        }

        const isSubscription = $('.pdp-main__frequency.sub.active, .pdp-main__frequency-selector-plan.active').length > 0;
        let sellingPlanId = '';
        if (isSubscription) {
          const $activePlan = $('.pdp-main__frequency-selector-plan.active');
          if ($activePlan.length) {
            sellingPlanId = $activePlan.data('selling-plan-id') || '';
          } else {
            const $subscriptionFrequency = $('.pdp-main__frequency.sub.active');
            if ($subscriptionFrequency.length) {
              sellingPlanId = $subscriptionFrequency.data('selling-plan-id') || '';
            }
          }
        }

        const items = selectedVariants.map(id => ({
          id,
          quantity: 1,
          ...(sellingPlanId && { selling_plan: sellingPlanId })
        }));
        $.post(cartUrl + '/add.js', { items })
          .done(() => {
            if (window.onAddToCartSuccess) window.onAddToCartSuccess(cartUrl);
            else window.location.href = cartUrl;
          })
          .fail(() => alert('Error adding items to cart.'));
      } else if ($('.pdp-main__bogo-options').length > 0) {
        // BOGO selector mode
        const $activeOption = this.getActiveBogoOption();
        if (!$activeOption.length) {
          return alert('Please select a product option.');
        }

        const selectedVar = this.selectedVar;
        const id = selectedVar.data('id');
        if (!id) return alert('Please select a product option.');

        const $subscriptionCheckbox = $('.pdp-main__sub-input');
        const isSubscription = $subscriptionCheckbox.length && $subscriptionCheckbox.is(':checked');
        let sellingPlanId = '';
        if (isSubscription) {
          sellingPlanId = $subscriptionCheckbox.data('selling-plan-id') || $activeOption.data('selling-plan-id') || '';
        }

        const prices = this.calculateBogoOptionPrice($activeOption);
        const { paidQuantity, freeQuantity, quantity } = prices;

        const bogoSubscriptionAllWithSellingPlan = !!$('.pdp-main__bogo-options').data('subscription-all-with-plan');
        const items = isSubscription
          ? bogoSubscriptionAllWithSellingPlan
            ? [{ id, quantity: quantity || paidQuantity + freeQuantity, ...(sellingPlanId && { selling_plan: sellingPlanId }) }]
            : [
              ...(paidQuantity > 0 ? [{ id, quantity: paidQuantity, ...(sellingPlanId && { selling_plan: sellingPlanId }) }] : []),
              ...(freeQuantity > 0 ? [{ id, quantity: freeQuantity }] : [])
            ]
          : [{ id, quantity: quantity || paidQuantity + freeQuantity }];

        $.post(cartUrl + '/add.js', { items })
          .done(() => {
            if (window.onAddToCartSuccess) window.onAddToCartSuccess(cartUrl);
            else window.location.href = cartUrl;
          })
          .fail(() => alert('Error adding item to cart.'));
      } else {
        // Standard variant selector mode
        const selectedVar = this.selectedVar;
        const id = selectedVar.data('id');
        if (!id) return alert('Please select a product option.');

        const $subscriptionCheckbox = $('.pdp-main__sub-input');
        const isSubscription = $subscriptionCheckbox.length && $subscriptionCheckbox.is(':checked');
        let sellingPlanId = '';
        if (isSubscription) {
          sellingPlanId = $subscriptionCheckbox.data('selling-plan-id') || '';
        }

        const items = [{
          id,
          quantity: 1,
          ...(sellingPlanId && { selling_plan: sellingPlanId })
        }];
        $.post(cartUrl + '/add.js', { items })
          .done(() => {
            if (window.onAddToCartSuccess) window.onAddToCartSuccess(cartUrl);
            else window.location.href = cartUrl;
          })
          .fail(() => alert('Error adding item to cart.'));
      }
    });
  }
};

$(document).ready(function () {
  Product.init();
});
